import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { device } from "../../helpers/style";
import { COLORS, TYPE_PRIMARY } from "../ui";

export const BTN_SMALL = "btn/small";
export const BTN_MEDIUM = "btn/medium";
export const BTN_ROUND = "btn/round";

const styles: Record<string, Record<string, string>> = {
    [BTN_SMALL]: {
        height: "33px",
        fontSize: "14px",
        fontWeight: "500",
        borderRadius: "3px",
        padding: "0 16px",
        spanTop: "-2px",
    },
    [BTN_MEDIUM]: {
        height: "44px",
        fontSize: "18px",
        fontWeight: "500",
        borderRadius: "3px",
        padding: "0 40px",
        spanTop: "-3px",
    },
    [BTN_ROUND]: {
        height: "33px",
        fontSize: "16px",
        fontWeight: "500",
        borderRadius: "50%",
        spanTop: "-2px",
    },
};

const mobileStyles: Record<string, Record<string, string>> = {
    [BTN_SMALL]: {
        height: "33px",
        lineHeight: "33px",
        fontSize: "14px",
        fontWeight: "500",
        borderRadius: "3px",
        padding: "0 16px",
    },
    [BTN_MEDIUM]: {
        height: "40px",
        lineHeight: "40px",
        fontSize: "16px",
        fontWeight: "500",
        borderRadius: "3px",
        padding: "0 30px",
    },
};

export const Container = styled.div<
    Record<"size" | "width" | "type" | "margin", string>
>`
    position: relative;
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s;
    font-family: Cairo, QuranFont, urdu, sans-serif;
    font-weight: ${(p) => styles[p.size]["fontWeight"]};
    white-space: nowrap;
    width: ${(p) => p.width};
    height: ${(p) => styles[p.size]["height"]};
    line-height: ${(p) => styles[p.size]["lineHeight"]};
    margin: ${(p) => p.margin};
    padding: ${(p) => styles[p.size]["padding"]};
    border-radius: ${(p) => styles[p.size]["borderRadius"]};
    background-color: ${(p) => COLORS[p.type]["backgroundColor"]};
    color: ${(p) => COLORS[p.type]["color"]};
    font-size: ${(p) => styles[p.size]["fontSize"]};

    &:hover,
    & span:hover {
        color: ${(p) => COLORS[p.type]["hoverColor"]};
        background-color: ${(p) => COLORS[p.type]["hoverBackgroundColor"]};
    }

    span {
        position: relative;
        font-family: Cairo, QuranFont, urdu, sans-serif;
    }

    @media ${device.phone} {
        font-size: ${(p) => mobileStyles[p.size]["fontSize"]};
        padding: ${(p) => mobileStyles[p.size]["padding"]};
        height: ${(p) => mobileStyles[p.size]["height"]};
        line-height: ${(p) => mobileStyles[p.size]["lineHeight"]};
    } ;
`;

export const ButtonGroup = styled.div<{
    margin?: string;
    width?: string;
}>`
    margin: ${(p) => p.margin || "60px 0 0 0 "};
    width: ${(p) => p.width || "100%"};
    display: flex;
    justify-content: center;
`;

type ButtonProps = {
    size?: string;
    width?: string;
    type?: string;
    margin?: string;
    messageId: string;
    onClick: (evt: React.MouseEvent<HTMLElement>) => void;
};
export function Button({
    size = BTN_SMALL,
    width = "auto",
    type = TYPE_PRIMARY,
    margin = "0 5px",
    messageId,
    onClick,
}: ButtonProps) {
    return (
        <Container
            width={width}
            size={size}
            type={type}
            margin={margin}
            onClick={onClick}
        >
            <FormattedMessage id={messageId} />
        </Container>
    );
}
